export const OfficeFlexjobsEditState = {
	url: '/flexjob/edit/:id',
	title: 'Office Edit Flexjob',
	template: '<edit-flexjob-page></edit-flexjob-page>',
	params: {
		id: null,
	},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeFlexjobsEditPageMod" */
			'@Containers/office-flexjobs-page/edit/office-flexjobs-edit.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
